<div class="menu-order-tree-container" *transloco="let t">
  <div class="heading-container">
    <button class="close-button button-clear" (click)="modalService.closeModal()" [ariaLabel]="'Close'">
      <cwo-round-icon [iconName]="iconNameType.close" [size]="'medium'" />
    </button>
    <span class="title">
      {{ title() }}
    </span>
  </div>

  <cwo-order-details-button [isInCart]="true" class="order-details"></cwo-order-details-button>

  @if (order().items?.length || order().specials?.length || order().pendingSpecial || order().adjustments?.length || orderWarnings().length || order().fundraisers?.length || pendingApplicationCoupon()) {
  <div class="order-items-container" #orderItemsContainer>
    <div class="primary-container">
      <div class="primary-group">
        @if(orderedSpecials().length || items().length || order().fundraisers?.length){
          <div class="special-items-container" [ngClass]="{'bottom': !items().length}">
            @if(orderedSpecials().length){
              <div class="ordered-specials-group">
                @for (special of orderedSpecials(); track $index) {
                  <cwo-ordered-special [special]="special" [triggeringArea]="'Order Tree'"/>
                }
              </div>
            }

            <div class="cart-item-entry-group" [ngClass]="{'top': !orderedSpecials().length}">
              @for (item of items(); track item.itemId;) {
                  <cwo-cart-item-entry [item]="item" [triggeringArea]="'Order Tree'"></cwo-cart-item-entry>
              }
            </div>
            
            @if(order().fundraisers?.length) {
              @for (fundraiser of order().fundraisers; track $index; let last = $last) {
                <cwo-order-tree-fundraiser
                  [fundraiser]="fundraiser"
                  [isLast]="last"
                  (removeFundraiser)="removeFundraiser($event)"
                  [loadingSubscription]="fundraiserLoadingSubscription"
                />
                <div class="divider"></div>
              }
            }

            <div class="clear-order-button-wrapper">
              <button class="button-undecorated clear-order-button" (click)="clearOrder()">
                <cwo-icon [name]="iconNameType.delete" class="icon"/>
                {{t('modals.cart.clear_order')}}
              </button>
            </div>
          </div>
        }

        @if (order().pendingSpecial || order().adjustments?.length || deliveryDiscountSpecial() || pendingApplicationCoupon()) {
            <div class="pending-special-adjustments-group">
              @if (order().pendingSpecial) {
                <div class="pending-special-container">
                  <cwo-pending-special [special]="order().pendingSpecial!" />
                </div>
              }
        
              @if(order().adjustments?.length || deliveryDiscountSpecial()){
                <div class="adjustments-wrapper">
                  @if(deliveryDiscountSpecial()) {
                    <cwo-subscription-special [special]="deliveryDiscountSpecial()!"/>
                  }
                  @for (adjustment of order().adjustments; track $index) {
                    @if (adjustment.type === adjustmentType.LOYALTY_PERK) {
                      <cwo-subscription-special [special]="adjustment"/>
                    } @else {
                      <cwo-adjustment [adjustment]="adjustment"/>
                    }
                  }
                </div>
              }

              @if (pendingApplicationCoupon() && !order().pendingSpecial) {
                <div class="pending-application-coupon-chip-wrapper">
                  <cwo-pending-special [special]="pendingApplicationCouponAsOrderable()" (removed)="accountCouponsService.removePendingApplicationCoupon()" />
                </div>
              }
            </div>
        }
      </div>
      @if(configService.configState().store?.showSubTotalOnly){
        <div class="subtotal-wrapper">
          <cwo-order-charge-fee
            [ngStyle]="{ 'margin-top': '7px' }"
            [feeName]="'Subtotal'"
            [isTotal]="true"
            [feeValue]="order().subTotal"
            [isBold]="true"
            [fontSize]="'var(--font-size-lg)'"
            [lineHeight]="'var(--font-size-xl)'"
          ></cwo-order-charge-fee>
          <span class="final-amount-text">{{t('modals.cart.final_amount_may_vary')}}</span>
        </div>
        
      } @else {
        <div class="additional-charges-wrapper">
            <cwo-expandable-component [overflowVisible]="expanded" (isExpanded)="handleExpansion($event)" [headerStyle]="'right'" [ariaControlsName]="'ClickMe'">
              <ng-template #heading>
                <div class="order-charges-header">
                  <span>{{t('modals.cart.additional_charges')}}</span>
                  <cwo-icon class="arrow-icon" [name]="iconNameType.arrow" [ngStyle]="{
                    transform: expanded ? 'rotate(-180deg)' : 'rotate(0deg)'
                  }" />
                </div>
              </ng-template>
              <ng-template #content>
                <div class="order-charges-details-group">
                  <cwo-order-charge-details [order]="order()" [generalFeeGap]="'7px'" [marginTopTotal]="'7px'" />
                </div>
              </ng-template>
            </cwo-expandable-component>        
        </div>
      }
      @if(order().subTotal > 0 && !hasActiveSub()) {
        <cwo-cart-sub-promo></cwo-cart-sub-promo>
      }
    </div>
      @if (selfOrderWarning()) {
    <div class="self-order-warning-wrapper" role="alert">
      <span class="self-order-warning-text">{{ selfOrderWarning()?.text }}</span>
      <button class="button-undecorated start-over-button" type="button" (click)="startOverSelfOrder()">
        {{t('modals.cart.start_over')}}
      </button>
    </div>
  }
    @if(configService.configState().store?.checkoutUpsellArea === checkoutUpsellArea.MENU) {
      <cwo-upsells [triggeringArea]="'Order Tree'"/>
    }
  </div>

  @if (orderWarnings().length) {
    @for (warning of orderWarnings(); track $index) {
      <cwo-order-warning [warning]="warning" (instructionButtonClicked)="handleInstruction($event)" />
    }
  }

  @if (pendingApplicationCoupon() && !order().pendingSpecial) {
    <div class="pending-application-coupon-wrapper">
      <cwo-order-warning [warning]="pendingApplicationCouponWarning()!" [showInstructions]="true" (instructionButtonClicked)="handlePendingApplicationCouponInstruction()" />
    </div>
  }

  @if(configService.configState().store?.hasLoyalty && !configService.configState().store?.hasThirdPartyLoyalty){
    <cwo-loyalty-indicator />
  }

  <div class="checkout-button-container" [ngClass]="{'coupon-error': !!allErrors?.length}">
    @if (accountState().isLoggedIn && configService.configState().store?.hasLoyalty) {
      <button class="available-coupons-container" type="button" (click)="showAddCouponModal()">
        <div class="primary-container">
          <cwo-icon [name]="iconNameType.coupon" />
          <span class="apply-text">{{t('modals.cart.apply_coupons')}}</span>
        </div>
        <div class="second-container">
          <span class="available-text">{{t('modals.cart.available_coupons', { count: coupons().length }) }}</span>
          <cwo-icon class="next-icon" [name]="iconNameType.next" />
        </div>
      </button>
    } @else {
      <div class="coupon-input-with-errors">
        <cwo-coupon-input class="coupon-input-container" [isInValid]="!!allErrors?.length" (formSubmitted)="handleApplyCoupon($event)" />
        @if(allErrors?.length) {
          <div class="generic-errors">
              @for (error of allErrors; track $index) {
                  <span class="error"><cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>{{!error.trim().endsWith('.') ? error + ('.') : error}}</span>
              }
          </div>
        }
      </div>
    }
    <cwo-accent-button [ariaLabel]="'Check out'" style="width: 100%;" [fullWidth]="true"  [routerLink]="storeIdService.getRoutePathSegments(['checkout'])" [state]="{triggeringArea: 'Order Tree', triggeringPoint: 'Checkout button'}">
      <div class="checkout-button">
        <span>{{t('modals.cart.checkout')}}</span>
        <span class="base-amount">{{(configService.configState().store?.showSubTotalOnly ? order().subTotal.toFixed(2) : order().price.toFixed(2)) | currency:'USD'}}</span>
      </div>
    </cwo-accent-button>
  </div>
  } @else {
  <!-- empty cart -->
  <div class="empty-cart-wrapper">
    @if (selfOrderWarning()) {
      <div class="self-order-warning-wrapper" role="alert">
        <span class="self-order-warning-text">{{ selfOrderWarning()?.text }}</span>
        <button class="button-undecorated start-over-button" type="button" (click)="startOverSelfOrder()">
          {{t('modals.cart.start_over')}}
        </button>
      </div>
    }

    @if (unsubmittedCoupon()) {
      <div class="pending-special-container">
        <cwo-pending-special [special]="order().pendingSpecial!" />
      </div>
    }
    <div class="primary-group">
      <img src="../../../assets/icons/empty-cart.png" [alt]="'Empty Cart'" class="empty-cart-image">
      <div class="text-container">
        <span class="main-text">{{t('modals.cart.no_items')}}</span>
        <span class="secondary-text">{{t('modals.cart.add_items_prompt')}}</span>
      </div>
      <button class="button-accent start-shopping-button" (click)="goBackToShopping()">
        {{t('modals.cart.start_shopping')}}
      </button>
      @if (unsubmittedCoupon()) {
        <div class="warnings-wrapper">
          <cwo-order-warning [warning]="couponAppliedOnMissingOrderWarning" (instructionButtonClicked)="handleAddOrderDetails()" />
        </div>
        }
    </div>
   
    @if (accountState().isLoggedIn && configService.configState().store?.hasLoyalty) {
      <div class="available-coupons-wrapper">
        <button class="available-coupons-container" type="button" (click)="showAddCouponModal()">
          <div class="primary-container">
            <cwo-icon [name]="iconNameType.coupon" />
            <span class="apply-text">{{t('modals.cart.apply_coupons')}}</span>
          </div>
          <div class="second-container">
            <span class="available-text">{{t('modals.cart.available_coupons', { count: coupons().length })}}</span>
            <cwo-icon class="next-icon" [name]="iconNameType.next" />
          </div>
        </button>
      </div>
    } @else {
      <div class="coupon-input-with-errors">
        <cwo-coupon-input #couponInputField class="coupon-input-container" [isInValid]="!!allErrors?.length" (formSubmitted)="handleApplyCoupon($event)" />
        @if(allErrors?.length) {
          <div class="generic-errors" [@openClose]>
              @for (error of allErrors; track $index) {
                  <span class="error"><cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>{{!error.trim().endsWith('.') ? error + ('.') : error}}</span>
              }
          </div>
        }
      </div>
    }
  </div>
  }
</div>

<ng-template #couponInstructionModal>
  @for (orderWarning of orderWarnings(); track $index) {
    @if ((orderWarning.type === orderWarningType.ORDER && displayPendingWarning) || 
         (orderWarning.type === orderWarningType.SPECIAL && !displayPendingWarning)) {
      
      <div class="instruction-modal-container" *transloco="let t">
        <span class="special-name">
          {{ orderWarning.type === orderWarningType.ORDER ? order().pendingSpecial?.name : orderWarningSpecial().name }}
        </span>
  
        <div class="instruction-disclaimer-group">
          @if ((orderWarning.type === orderWarningType.ORDER && order().pendingSpecial?.instructions) || 
               (orderWarning.type === orderWarningType.SPECIAL && orderWarningSpecial().instructions)) {
            <div class="title-text-wrapper">
              <span class="modal-title">{{t('modals.cart.how_to_apply')}}</span>
              <span class="modal-text">{{ order().pendingSpecial?.instructions }}</span>
            </div>
          }
    
          @if (order().pendingSpecial?.disclaimer) {
            <div class="instructions-wrapper">
              <span class="modal-title">{{t('modals.cart.note')}}</span>
              <span class="modal-text">{{ order().pendingSpecial?.disclaimer }}</span>
            </div>
          }
          @if(order().pendingSpecial?.errorType !== 'APPLICATION_FAILED' && order().pendingSpecial?.error) {
            <span class="modal-text">{{order().pendingSpecial?.error?.endsWith('.') ? order().pendingSpecial?.error : order().pendingSpecial?.error + '.'}}</span>
          }
        </div>
      </div>
    }
  }  
</ng-template>

<ng-template #couponWarningModal>
  <cwo-coupon-conflict [couponWarning]="couponWarning"></cwo-coupon-conflict>
</ng-template>

<ng-template #pendingApplicationCouponInstructionModal>
  <div class="instruction-modal-container" *transloco="let t">
    <span class="special-name">{{ pendingApplicationCouponAsOrderable()?.name }}</span>
    <div class="instruction-disclaimer-group">
      @if (pendingApplicationCouponAsOrderable()?.instructions) {
        <div class="title-text-wrapper">
          <span class="modal-title">{{t('modals.cart.how_to_apply')}}</span>
          <span class="modal-text">{{ pendingApplicationCouponAsOrderable()?.instructions }}</span>
        </div>
      }
    </div>
  </div>
</ng-template>
